import React from 'react';

function SpecialInstructions({ name, instructions, label }) {
  return (
    <article className="text-base text-neutral-800 font-semibold bg-neutral-100 p-3 rounded sm:col-span-3">
      {label || 'Special Instructions'}
      {instructions.split('\n\n').map((paragraph, index) => (
        // eslint-disable-next-line react/no-array-index-key
        <p key={`${name}-${index}`} className="font-normal">
          {paragraph
            .split('\n')
            .reduce((total, line) => [total, <br key={line} />, line])}
        </p>
      ))}
    </article>
  );
}

export default SpecialInstructions;
